/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档



export interface API75094Req {
  
  /** 业务编号 */
  bizNo?: string;
  /** 业务类型 */
  bizType?: string;
  /**  */
  sessionToken?: string;
};



export type API75094Res = string;


// 接口函数 75094 生成会议纪要

export interface IUsePostAPI75094Return {
  /** 生成会议纪要: 接口请求状态 */
  isAPI75094Loading: boolean;
  /** 生成会议纪要: 接口请求返回数据 */
  dataAPI75094: API75094Res;
  /**  生成会议纪要: 接口数据请求方法 */
  fetchAPI75094Data: (inputs: API75094Req, config?: YWRequestConfig) => Promise<API75094Res>;
  /** 生成会议纪要: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI75094 = ():IUsePostAPI75094Return => {
  let isMount = true;
  const [isAPI75094Loading, setIsAPI75094Loading] = useState(false);
  const [dataAPI75094, setDataAPI75094] = useState<API75094Res>({} as API75094Res);
  const requestUrl = `${basePath}/yoaichat-web/chat/meeting/content`;

  const fetchAPI75094Data = async (inputs: API75094Req, config?: YWRequestConfig): Promise<API75094Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API75094Req>) || {}) as API75094Req;
    
  
    if ( isMount ) {
      setIsAPI75094Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API75094Res>(`${basePath}/yoaichat-web/chat/meeting/content`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI75094(res || {} as API75094Res);
        setIsAPI75094Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI75094Loading(false);
      }
      return false as unknown as API75094Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI75094Loading,
    dataAPI75094,
    fetchAPI75094Data,
    requestUrl,
  }
}

